import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../axios';
import { responseHandler } from '../utils';

type MutationParams = {
    userId: string;
    associatedOrganization: string;
};

export const usePostChangeUserOrganization = (
  options?: UseMutationOptions<void, AxiosError, MutationParams>,
): UseMutationResult<void, AxiosError, MutationParams> => useMutation<void, AxiosError, MutationParams>({
  mutationFn: ({ userId, associatedOrganization }) => axiosInstance.post(
    '/v3-changeUserOrganization',
    { userId, associatedOrganization },
    {
      headers: { 'Content-Type': 'application/json' },
    },
  ).then(responseHandler),
  ...options,
});
